import { Link } from 'react-router-dom'
import styled from 'styled-components'

import MenuText from './DropdownMenuText'
import { IDropdownMenuTextLink } from 'features/Navbar/NavbarRevamp/navbarRevamp.types'

const WrappedLink = styled(Link)`
  cursor: pointer;
  text-decoration-line: none;
  margin: auto 0;
  display: flex;
  line-height: 16px;
`
const DropdownMenuTextLink = ({
  to,
  className,
  isNew = false,
  newPosition = 'end',
  message,
  target,
  onClick,
  testId,
  id,
  count,
  iconName,
}: IDropdownMenuTextLink) => (
  <WrappedLink
    to={to}
    target={target}
    data-testid={testId}
    id={id}
    className="menuTextLink"
  >
    <MenuText
      className={className}
      isNew={isNew}
      newPosition={newPosition}
      message={message}
      onClick={onClick}
      count={count}
      iconName={iconName}
    />
  </WrappedLink>
)
export default DropdownMenuTextLink
